import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c0ffbbd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1c0ffbbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ffbbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0ffbbd')) {
      api.createRecord('1c0ffbbd', component.options)
    } else {
      api.reload('1c0ffbbd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c0ffbbd&scoped=true&", function () {
      api.rerender('1c0ffbbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rolls/components/RoomItem/index.vue"
export default component.exports